$(document).on('turbolinks:load', function () {
  if (!$('body').hasClass('controller-public-hotsites-skins')) return;

  $('.hotsite-skins-filters select').on('change', function () {
    $(this).closest('form').trigger('submit');
  });

  const $gross = $('.skins-report-gross');
  const $net = $('.skins-report-net');
  const hasGross = $gross.length > 0;
  const hasNet = $net.length > 0;

  if (hasGross && hasNet) {
    $net.hide();
    $('.hotsite-skins-type-toggle-wrapper').show();
  } else if (!hasGross || !hasNet) {
    $('.hotsite-skins-type-toggle-wrapper').hide();
  }

  $('input.switch-input').hide();
  setTimeout(function () {
    $('input.hotsite-skin-type-toggle').each(function () {
      $(this).bootstrapSwitch('state', true);
      $(this).on('switchChange.bootstrapSwitch', function (_event, state) {
        if (state) {
          $gross.show();
          $net.hide();
        } else {
          $gross.hide();
          $net.show();
        }
      });
    });
  }, 300);
});
